import { createSlice } from "@reduxjs/toolkit";
import { fetchSupplierMaster } from "./thunk";

interface PRState {
  list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: PRState = {
  list: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const ProjectManagerManpowerSlice = createSlice({
  name: "ProjectManagerManpower",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSupplierMaster.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSupplierMaster.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchSupplierMaster.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch supplier  List";
      });
  },
});

export default ProjectManagerManpowerSlice.reducer;
